__turbopack_context__.v({
  "className": "geistmono_93e61c19-module__42ewiG__className",
  "variable": "geistmono_93e61c19-module__42ewiG__variable",
});
